<template>
  <div class="shop-detail">
    <!--<van-nav-bar class="" :title="shopDetail.shopName" left-arrow @click-left="onClickLeft" :border="false"/>-->
    <!--
    <van-swipe class="swipe" :autoplay="3000" indicator-color="white" >
      <van-swipe-item v-for="(i) in 3" :key="i">
        <img style="width: 100%;height: 100%;" src="../../assets/mall/dev-banner-shop.png" alt="">
      </van-swipe-item>
    </van-swipe>
    <div class="bg-10px"></div>
    -->
    <div style="height: 4px;"></div>
    <div class="shop">
      <div class="shop-img-con" @click="goMallShopDetail">
        <div class="shop-img">
          <img class="img" :src="shopDetail.shopAvatar+'?imageView2/0/w/110/h/110'" alt="">
          <div v-if="shopDetail.isVipShop" class="is-vip"></div>
        </div>
      </div>
      <div class="name-con" @click="goMallShopDetail">
        <div class="name">{{ shopDetail.shopName }} &nbsp;</div>
        <div class="num-com">
          <span class="num">{{ shopDetail.focusUserCount }} 关注</span>
          <span class="num">{{ shopDetail.orderCount }} 已售</span>
          <span class="num">{{ shopDetail.goodsCount }} 商品</span>
        </div>
      </div>
      <div class="follow-con" v-if="userOpenId !== shopDetail.userId">
        <div class="follow-btn follow-btn-true" v-if="shopDetail.isUserFocus" @click="changeFocusShop">已关注</div>
        <div class="follow-btn follow-btn-false" v-if="!shopDetail.isUserFocus" @click="changeFocusShop">关注</div>
      </div>
    </div>
    <div class="shop-member-con" v-if="giftDetail && giftDetail.giftStatus===2">
      <div class="shop-member">
        <div class="vip-icon"></div>
        <div class="text">店铺会员</div>
        <div class="now-price">￥<span class="now-num">{{ giftDetail.giftSellPrice }}</span></div>
        <div class="old-price"><s>原价:￥{{ giftDetail.giftOriginalPrice }}</s></div>
        <div class="buy-btn-con">
          <div class="btn is-buy" v-if="giftDetail.disPlay===1" @click="goMallShopMember">查看详情</div>
          <div class="btn no-buy" v-if="giftDetail.disPlay===2" @click="goMallShopMember">开通会员</div>
        </div>
      </div>
    </div>
    <div class="bg-10px"></div>

    <div class="center-con" :style="{top: ((giftDetail&&giftDetail.giftStatus===2)?140:70) +'px'}">
      <van-cell :is-link="columnTotal>10" @click="goMallShopGoodsMore('3')">
        <div class="goods-total" slot="title">
          <i class="icon"></i>专栏 <span>({{ columnTotal }})</span>
          <span class="right" v-if="columnTotal>10">更多</span>
        </div>
      </van-cell>
      <div class="popular-list">
        <div class="list" v-for="(item, i) in courseSeriesVos" :key="i" @click="goDetail(item)">
          <div class="img-con">
            <img class="img" :src="item.coverPath+'?imageView2/0/w/200/h/150'" alt="">
          </div>
          <div class="text-con">
            <div class="list-title"><span class="type">{{ knowledgeTypeName(null) }}</span>{{ item.title }}</div>
            <div class="sub-text">
              <span class="num">已更新{{ item.currentCourseCount }}期</span>
              <span class="num">收藏:{{ item.collectUserCount }}</span>
              <span class="num">已售:{{ item.salesVolume }}</span>
              <span class="price">{{ item.sellPrice===0?'免费':('￥'+item.sellPrice) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-10px"></div>
      <van-cell :is-link="courseTotal>10" @click="goMallShopGoodsMore('2')">
        <div class="goods-total" slot="title">
          <i class="icon"></i>课程 <span>({{ courseTotal }})</span>
          <span class="right" v-if="courseTotal>10">更多</span>
        </div>
      </van-cell>
      <div class="popular-list">
        <div class="list" v-for="(item, i) in courseVos" :key="i" @click="goDetail(item)">
          <div class="img-con">
            <img class="img" :src="item.coverPath+'?imageView2/0/w/200/h/150'" alt="">
          </div>
          <div class="text-con">
            <div class="list-title"><span class="type">{{ knowledgeTypeName(item.courseType) }}</span>{{ item.title }}</div>
            <div class="sub-text">
              <span class="num" v-if="item.courseType!==null">时长:{{ item.duration }}min</span>
              <span class="num">收藏:{{ item.collectUserCount }}</span>
              <span class="num">已售:{{ item.salesVolume }}</span>
              <span class="price">{{ item.sellPrice===0?'免费':('￥'+item.sellPrice) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>


<!--

    <div class="download-con">
      <div class="img-con">
        <img class="img" src="../../assets/logo.png" alt="">
      </div>
      <div class="text-con">
        <div class="name">蚂蚁报信</div>
        <div class="text">我的私域流量我做主</div>
      </div>
      <div class="btn-con">
        <div class="btn" @click="goInvitePage">立即下载</div>
      </div>
    </div>
-->


    <wx-config v-on:wxConfigReady="wxConfigReady" />
  </div>
</template>

<script>
import { introduce, focusShop } from '@/api/mall/mallShop'
import { getShopHomeInfo } from '@/api/mall/mallGoods'
import { giftInfo } from '@/api/member'
import wxConfig from '@/components/weixin/wxConfig'
export default {
  components: {
    wxConfig
  },
  data(){
    return {
      shopDetail: {},
      userOpenId: this.session('userOpenId') || '',
      // resData:{},

      columnTotal: 0, // 专栏总数
      courseSeriesVos: [], // 专栏

      courseTotal: 0, // 课程总数
      courseVos: [], // 课程

      outInviteCode: '',// 店铺被 分享用户分享，用openId 获取的邀请码

      giftDetail: {},//店铺会员礼包详情

      origin: window.location.origin,
    }
  },
  created(){
    if(this.$route.query.shopId){
      this.getShopHome()
      this.getShopGoods()
      this.getGiftInfo()
      // if(this.session('userOpenId')){
      //
      // }
    }
    if(this.$route.query.inviteUserId){
      this.getUserByUserInfo()
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },

    getShopHome() {
      introduce({shopId: this.$route.query.shopId}).then(res=>{
        this.shopDetail = res.data;
        document.title = this.shopDetail.shopName
      })
    },
    changeFocusShop() {
      focusShop({shopId: this.$route.query.shopId}).then(res=>{
        this.getShopHome()
      })
    },
    getShopGoods(){
      let req = {shopId: this.$route.query.shopId, page: 1, size: 10};
      req.typeId = '1'; // 商品分类： 1 全部 ，2 课程， 3 专栏
      if(this.$route.query.inviteUserId){
        req.inviteUserId = this.$route.query.inviteUserId
      }
      getShopHomeInfo(req).then(res=>{
        // this.resData = res.data
        this.columnTotal = res.data.columnTotal || 0;
        this.courseSeriesVos = res.data.courseSeriesVos || [];
        this.courseTotal = res.data.courseTotal || 0;
        this.courseVos = res.data.courseVos || [];
      })
    },

    goMallShopGoodsMore(typeId){
      let mallShopGoodsMoreQuery = {shopId: this.$route.query.shopId, typeId}
      if(this.$route.query.inviteUserId){
        mallShopGoodsMoreQuery.inviteUserId = this.$route.query.inviteUserId
      }
      if(typeId==='2'){ // 更多课程
        (this.courseTotal>10) && (this.$router.push({name: 'mallShopGoodsMore', query: mallShopGoodsMoreQuery}))
      }else if(typeId==='3'){ // 更多专栏
        (this.columnTotal>10) && (this.$router.push({name: 'mallShopGoodsMore', query: mallShopGoodsMoreQuery}))
      }
    },


    // 跳转至商品详情
    goDetail(item) {
      let query = {goodsId: item.goodsId, shopId: this.$route.query.shopId, courseType: item.courseType||null };
      if(this.$route.query.inviteUserId){
        query.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'goodsDetail', query })
    },
    // 跳转至店铺
    goMallShopDetail(){
      console.log(this.$route.query.shopId)
      this.$router.push({name: 'mallShopDetail', query: {shopId: this.$route.query.shopId}})
    },

    //获取是否拥有店铺会员功能
    getGiftInfo(){
      let req = {shopId: this.$route.query.shopId}
      if(this.session('userOpenId')){
        req.openid=this.session('userOpenId')
      }
      giftInfo(req).then(res=>{
        if(res.code===200){
          this.giftDetail = res.data
        }
      })
    },


    //跳转至店铺会员礼包详情
    goMallShopMember(){
      this.$router.push({name: 'mallShopMember', query: this.$route.query})
    },

    // 获取用户信息
    getUserByUserInfo(){
      getUserByUserInfo({openId: this.$route.query.inviteUserId}).then(res=>{
        if(res.data){
          this.outInviteCode = res.data.inviteCode
        }
      })
    },
    // 推广链接跳转
    // goInvitePage(){
    //   let inviteCode = '';
    //   if(this.$route.query.inviteUserId){ //如果邀请链接中有 邀请人的openId
    //     inviteCode = this.outInviteCode;
    //   }else {
    //     inviteCode = this.session('user').inviteCode || '0608';
    //   }
    //   let url = '/h5/register?inviteCode='+ inviteCode
    //   this.$router.push( url );
    // },

    // 微信分享
    wxConfigReady(){
      window.setTimeout(()=>{
        //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
        window.wx.updateAppMessageShareData({
          title: this.session('user').nickname + '给你分享了一个好店', // 分享标题
          desc: this.shopDetail.shopName, // 分享描述
          link: this.origin + '/mall/mallShop?shopId=' + (this.$route.query.shopId||this.shopId) + '&inviteUserId=' + this.session('userOpenId'),
          imgUrl: this.origin + this.shopDetail.shopAvatar, // 分享图标
          success: function () {
            // 设置成功
            console.log('店铺 设置分享朋友成功！')
          }
        });
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
        window.wx.updateTimelineShareData({
          title: this.session('user').nickname + '给你分享了一个好店', // 分享标题
          link: this.origin + '/mall/mallShop?shopId=' + (this.$route.query.shopId||this.shopId) + '&inviteUserId=' + this.session('userOpenId'),
          imgUrl: this.origin + this.shopDetail.shopAvatar, // 分享图标
          success: function () {
            // 设置成功
            console.log('店铺 设置分享朋友圈成功！')
          }
        })
      },300)

    },

  }
}
</script>

<style lang="less" scoped>
.shop-detail{
  position: relative;z-index: 0;width: 100%;height: 100%;overflow: hidden;
  /*padding-bottom: 60px;*/
  .shop{
    display: flex;
    .shop-img-con{
      width: 60px;
      height: 60px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      .shop-img{
        position: absolute;z-index: 0;width: 40px;height: 40px;
        .img{
          width: 100%;height: 100%;border-radius: 50%;
        }
        .is-vip{
          position: absolute;z-index: 0;top: -4px;left: -2px;
          width: 14.5px;height: 12.3px;
          background: url("../../assets/mall/shop-vip.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }

    .name-con{
      flex: 1;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      .name{
        color: #070707;
        line-height: 20px;
        font-size: 16px;
      }
      .num-com{
        line-height: 16px;
        .num{
          padding-right: 20px;
          color: #999;
          font-size: 10px;
        }

      }
    }
    .follow-con{
      display: flex;
      width: 70px;
      font-size: 10px;
      align-items: center;
      justify-content: center;
      color: #fff;
      padding-right: 10px;
      .follow-btn{
        width: 56px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 5px;
      }
      .follow-btn-true{
        background-color: #969799;
      }
      .follow-btn-false{
        background-color: #2b86cc;
      }
    }
  }

  .shop-member-con{
    padding: 12px;
    .shop-member{
      background-color: #d51d04;
      border-radius: 5px;
      height: 45px;
      display: flex;
      /*justify-content: flex-start;*/
      /*align-items: center;*/
      .vip-icon{
        width: 44px;height: 100%;margin-right: 0;
        background: url("../../assets/mall/mall-shop-vip.png") no-repeat 50% 50%;
        background-size: 26px 19px;
      }
      .text{margin-right: 0;font-size: 17px;color: #fff7da;height: 100%;display: inline-flex;align-items: center;}
      .now-price{
        flex: 1;display: inline-flex;justify-content: flex-end;align-items: center;
        color: #fff7da;font-size: 10px;white-space: nowrap;padding-right: 5px;
        .now-num{font-size: 19px;}
      }
      .old-price{
        min-width: 64px;max-width: 80px;display: inline-flex;justify-content: flex-end;align-items: center;
        color: #fff7da;font-size: 10px;white-space: nowrap;
      }
      .buy-btn-con{
        display: inline-flex;justify-content: center;align-items: center;
        width: 78px;height: 100%;
        align-self: flex-end;
        .btn{
          display: inline-flex;justify-content: center;align-items: center;
          width: 63px;height: 23px;font-size: 13px;border-radius: 5px;
          &.no-buy{
            color: #ea1c01;background-color: #ffe46c;
          }
          &.is-buy{
            color: #fff;background-color: #969799;
          }
        }
      }

    }
  }

  .center-con{
    position: absolute;left: 0;right: 0;
    bottom: 10px;
    width: 100%;
    overflow-y: auto;
    .goods-total{
      .icon{
        display: inline-block;
        width: 2px;
        height: 14px;
        font-size: 0;
        line-height: 44px;
        vertical-align: text-top;
        margin-right: 2px;
        background-color: #2590e2;
      }
      .right{
        float: right;
        color: #7d7e80;
      }
    }
    .popular-list{
      .list{
        height: 102px;
        padding: 12px;
        display: flex;
        border-bottom: 1px solid #edecec;
        background-color: #fff;
        .img-con{
          width: 100px;
          height: 75px;
          position: relative;
          .img{
            display: block;
            width: 100px;
            height: 75px;
          }
        }
        .text-con{
          justify-content: space-between;
          display: flex;
          flex-direction: column;
          flex: 1;
          padding-left: 10px;
          .list-title{
            margin-bottom: 2px;
            padding-bottom: 2px;
            font-size: 14px;
            /*height: 38px;*/
            color: #2b2b2b;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            .type{
              margin: 0 5px 0 0;
              font-size: 9px;
              border: .75px solid #1585f3;
              color: #1585f3;
              border-radius: 2px;
              padding: 1px 2.5px;
            }
          }
          .sub-text{
            font-size: 9px;
            color: #999;
            .num{
              padding-right: 6px;
            }
            .price{
              font-size: 14px;
              color: #f34b4b;
              float: right;
            }
          }
        }
      }
    }
  }
  /*
  .download-con{
    position: absolute;bottom: 0;left: 0;right: 0;
    width: 100%;
    display: flex;height: 55px;background-color: #e0f5ff;
    .img-con{
      width: 60px;
      display: inline-flex;justify-content: center;align-items: center;
      .img{
        display: block;width: 37px;height: 37px;border-radius: 5px;
      }
    }
    .text-con{
      flex: 1;display: inline-flex;flex-direction: column;
      justify-content: center;
      .name{
        font-size: 14px;color: #000;padding-bottom: 2px;
      }
      .text{font-size: 11px;color: #666;}
    }
    .btn-con{
      width: 87px;
      display: inline-flex;justify-content: center;align-items: center;
      .btn{
        display: inline-flex;justify-content: center;align-items: center;
        width: 63px;height: 28px;
        border: 1px solid #2686e8;color: #2686e8;border-radius: 3px;font-size: 11px;
      }
    }
  }
  */
}
</style>